import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PatternFormat } from "react-number-format";
import { getPhoneFormat } from "./PhoneInput";
import { LIST_ADULT_VERIFY_PROVIDER_OPTION } from "helpers/constans";
import moment from "moment";

interface VerifiedAdultInfoProps {
  verifiedInfoLog?: any;
  style?: any;
}

const VerifiedAdultInfo: React.FC<VerifiedAdultInfoProps> = ({
  verifiedInfoLog,
  style = {},
}) => {
  const { t } = useTranslation();

  const [isShowMore, setIsShowMore] = useState(false);
  let phoneNumber = verifiedInfoLog?.data?.No || "";
  const { format } = getPhoneFormat(phoneNumber);

  return verifiedInfoLog ? (
    <div className="">
      <div>
        <span className="fw-medium">{`${t("Provider")}: `}</span>
        {t(
          LIST_ADULT_VERIFY_PROVIDER_OPTION?.find(
            (item: any) => item?.value === verifiedInfoLog?.provider
          )?.label || ""
        )}
      </div>
      <div>
        <span className="fw-medium">{`${t("Name")}: `}</span>
        {verifiedInfoLog?.data?.Name || ""}
      </div>
      <div>
        <span className="fw-medium">{`${t("Phone Number")}: `}</span>
        <PatternFormat value={phoneNumber} displayType="text" format={format} />
      </div>

      <div className={`${isShowMore ? "d-block" : "d-none"} `}>
        <div>
          <span className="fw-medium">{`${t("Birthdate")}: `}</span>
          {verifiedInfoLog?.data?.Socialno
            ? moment(verifiedInfoLog?.data?.Socialno).format("YYYY-MM-DD")
            : ""}
        </div>
        <div>
          <span className="fw-medium">{`${t("Gender")}: `}</span>
          {verifiedInfoLog?.data?.Sex === "F" ? t("Female") : t("Male")}
        </div>
      </div>

      <span
        onClick={(e) => {
          e.preventDefault();
          setIsShowMore((prev) => !prev);
        }}
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
        className="link-primary fs-12 d-inline"
      >
        <span>{isShowMore ? t("View Less") : t("View More")}</span>
        <i
          className={`${
            isShowMore ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
          } fs-16 position-relative`}
          style={{ top: "4px" }}
        ></i>
      </span>
    </div>
  ) : (
    <>{t("Bypass adult verification via console")}</>
  );
};

export default VerifiedAdultInfo;
